/**
 * Toggle — accessible iOS-style switch.
 * Use as a controlled component (parent owns checked + onChange).
 */

import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
  'data-testid'?: string;
}

export function Toggle({
  checked,
  onChange,
  label,
  disabled,
  'data-testid': testId,
}: ToggleProps): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={styles.toggle}
      onClick={() => onChange(!checked)}
      data-testid={testId}
    />
  );
}
